import { api } from "@/api/client";

export interface TokenResponse {
  access_token: string;
  token_type: "bearer";
  expires_in: number;
  refresh_token: string;
}

export interface UserResponse {
  id: string;
  email: string;
  display_name: string;
  role: "admin" | "editor" | "viewer";
}

export const authApi = {
  login(email: string, password: string) {
    return api<TokenResponse>("/auth/login", {
      method: "POST",
      body: { email, password },
      anonymous: true,
    });
  },
  register(email: string, password: string, display_name: string) {
    return api<TokenResponse>("/auth/register", {
      method: "POST",
      body: { email, password, display_name },
      anonymous: true,
    });
  },
  refresh() {
    return api<TokenResponse>("/auth/refresh", {
      method: "POST",
      anonymous: true,
      noRefresh: true,
    });
  },
  logout(all = false) {
    return api<void>(`/auth/logout${all ? "?all=true" : ""}`, { method: "POST" });
  },
  me() {
    return api<UserResponse>("/auth/me");
  },
  changePassword(current_password: string, new_password: string) {
    return api<void>("/auth/change_password", {
      method: "POST",
      body: { current_password, new_password },
    });
  },
  forgotPassword(email: string) {
    return api<void>("/auth/forgot_password", {
      method: "POST",
      body: { email },
      anonymous: true,
    });
  },
  resetPassword(token: string, new_password: string) {
    return api<void>("/auth/reset_password", {
      method: "POST",
      body: { token, new_password },
      anonymous: true,
    });
  },
  verifyEmail(token: string) {
    return api<void>("/auth/verify_email", {
      method: "POST",
      body: { token },
      anonymous: true,
    });
  },
  resendVerification() {
    return api<void>("/auth/resend_verification", { method: "POST" });
  },
};
